import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CompaniesAPI from '../../api/companies';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getCompanies(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_COMPANY_UI_FLAG, { isFetching: true });
    try {
      const response = await CompaniesAPI.get();
      commit(types.SET_COMPANIES, response.data.payload);
      return response;
    } catch (error) {
      return null;
    } finally {
      commit(types.SET_COMPANY_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, companyInfo) => {
    commit(types.SET_COMPANY_UI_FLAG, { isCreating: true });
    try {
      const response = await CompaniesAPI.create({ company: companyInfo });
      commit(types.ADD_COMPANY, response.data);
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_COMPANY_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...companyInfo }) => {
    commit(types.SET_COMPANY_UI_FLAG, { isUpdating: true });
    try {
      const response = await CompaniesAPI.update(id, { company: companyInfo });
      commit(types.EDIT_COMPANY, response.data);
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_COMPANY_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_COMPANY_UI_FLAG, { isDeleting: true });
    try {
      await CompaniesAPI.delete(id);
      commit(types.DELETE_COMPANY, id);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_COMPANY_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_COMPANY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_COMPANIES]: MutationHelpers.set,
  [types.ADD_COMPANY]: MutationHelpers.create,
  [types.EDIT_COMPANY]: MutationHelpers.update,
  [types.DELETE_COMPANY]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
